// extracted by mini-css-extract-plugin
export default {"IconButton":"IconButton-module-c75b1984bc11418b8188","primary":"IconButton-module-c2ae4a9446c31f756e3c","secondary":"IconButton-module-dcee806b60654f415b75"};